import React, { useState } from "react";
import { Upload, message, Spin, Button } from "antd";
import { DeleteOutlined, LoadingOutlined, UploadOutlined, ReloadOutlined } from "@ant-design/icons";
// import './PayrollDeduction.css';
import "../../GlobalCss/SPF/PayrollDeduction.css";
const PayrollDeduction = () => {
    const [hrSourceFile, setHrSourceFile] = useState([]);
    const handleUpload = (options) => { }
    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (hrSourceFile.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ color: statusColor, width: "100%", display: "flex", justifyContent: "space-between", backgroundColor: "#f2f8fc", marginTop: "2px", borderRadius: "4px" }}>{fileExists ? hrSourceFile[0].file.name : null}<DeleteOutlined onClick={() => setHrSourceFile([])} /></div>
        </>;
    };
    const handleFileChange = ({ hrSourceFile: newFileList }) => {
        setHrSourceFile(newFileList);
    };
    return (<>
        <div className="whole-hrsource">
            <div className="source-file-uploader">
                <div className="upload-sync">
                    <div className="sourcefile-upload" style={{width:"40%"}}>
                        <div className="file-upload" style={{ height: "50px", width: "90%", borderRadius: "10px"}}>
                            <Upload.Dragger
                                name="file"
                                customRequest={handleUpload}
                                onChange={handleFileChange}
                                itemRender={itemRender}
                                fileList={hrSourceFile}
                                accept=".xls,.xlsx"
                                onRemove={() => setHrSourceFile([])}
                                style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}
                            >
                                <div className='content-file'>
                                    <span style={{ color: "rgba(196, 196, 196, 1)" }}>Upload Payroll Deduction File</span>
                                    {/* <UploadOutlined style={{ color: "#002766" }}/> */}
                                </div>
                            </Upload.Dragger>
                        </div>
                    </div>
                    <div className="sync-button-class">
                        <Button className="sync-button">Sync Data
                            <ReloadOutlined />
                        </Button>
                    </div>
                </div>
                <div className="csv-dwn-class">
                    <Button className="download-csv">Download .CSV
                        <UploadOutlined style={{ transform: "rotate(180deg)", marginLeft: 15, fontSize: 19 }} />
                    </Button>
                </div>
            </div>
        </div>
    </>)
}
export default PayrollDeduction;